module.exports = __webpack_public_path__ + "img/lock.2.5e8aee28.svg";